import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["minHeight", "color", "background", "family", "variant", "weight"];
var _VARIANTS, _templateObject;
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Typography } from '@material-ui/core';
import { spacing } from '@material-ui/system';
import styled from 'styled-components';
import React from 'react';
export var VARIANTS = (_VARIANTS = {
  tab: {
    size: 18,
    height: 24,
    weight: 400,
    family: 'Montserrat',
    spacing: 0
  },
  indicator: {
    size: 10,
    height: 16,
    weight: 600,
    family: 'Open Sans',
    spacing: 0
  },
  legal: {
    size: 12,
    height: 24,
    weight: 400,
    family: 'Open Sans',
    spacing: 0
  },
  caption: {
    size: 14,
    height: 24,
    weight: 400,
    family: 'Open Sans',
    spacing: 0
  },
  section: {
    size: 14,
    height: 24,
    weight: 600,
    family: 'Open Sans',
    spacing: 1
  },
  code: {
    size: 14,
    height: 24,
    weight: 400,
    family: 'Source Code Pro',
    spacing: 0
  },
  paragraph: {
    size: 16,
    height: 24,
    weight: 400,
    family: 'Open Sans',
    spacing: 0
  },
  button: {
    size: 16,
    height: 24,
    weight: 500,
    family: 'Open Sans',
    spacing: 0
  },
  h6: {
    size: 18,
    height: 24,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  h5: {
    size: 20,
    height: 32,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  h4: {
    size: 24,
    height: 32,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  h3: {
    size: 28,
    height: 40,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  h2: {
    size: 32,
    height: 40,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  h1: {
    size: 40,
    height: 48,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  display4: {
    size: 48,
    height: 56,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  display3: {
    size: 56,
    height: 64,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  display2: {
    size: 72,
    height: 80,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  },
  display1: {
    size: 88,
    height: 96,
    weight: 600,
    family: 'Montserrat',
    spacing: 0
  }
}, _defineProperty(_VARIANTS, "tab", {
  family: 'Montserrat',
  height: 24,
  size: 16,
  spacing: 0,
  weight: 600
}), _defineProperty(_VARIANTS, "title", {
  size: 18,
  height: 32,
  weight: 600,
  family: 'Open Sans',
  spacing: 0
}), _VARIANTS);
export var _Typography = styled(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function (_ref) {
  var minHeight = _ref.minHeight,
    color = _ref.color,
    background = _ref.background,
    family = _ref.family,
    variant = _ref.variant,
    weight = _ref.weight,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Typography, rest, rest.children);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    ", "\n    ", "\n  }\n\n  display: ", ";\n\n  &.MuiTypography-body1 {\n    ", "\n    font-size: ", "px;\n    ", "\n    letter-spacing: ", "px;\n    line-height: ", ";\n  }\n"])), getContrastColor, spacing, function (props) {
  return props.minHeight ? 'inline' : 'block';
}, getFontFamily, function (props) {
  return VARIANTS[props.variant].size;
}, getFontWeight, function (props) {
  return VARIANTS[props.variant].spacing;
}, function (props) {
  return props.minHeight ? 'normal' : "".concat(VARIANTS[props.variant].height, "px");
});
function getContrastColor(_ref2) {
  var _theme$palette, _theme$palette$color, _theme$palette2, _theme$palette2$prima;
  var background = _ref2.background,
    color = _ref2.color,
    theme = _ref2.theme;
  if (color && theme !== null && theme !== void 0 && (_theme$palette = theme.palette) !== null && _theme$palette !== void 0 && (_theme$palette$color = _theme$palette[color]) !== null && _theme$palette$color !== void 0 && _theme$palette$color.main) {
    return "color: ".concat(theme.palette[color].main, ";");
  } else if (color) {
    return "color: ".concat(color);
  }
  if (background === 'primary' && theme !== null && theme !== void 0 && (_theme$palette2 = theme.palette) !== null && _theme$palette2 !== void 0 && (_theme$palette2$prima = _theme$palette2.primary) !== null && _theme$palette2$prima !== void 0 && _theme$palette2$prima.contrastText) {
    return "color: ".concat(theme.palette.primary.contrastText, ";");
  }
  return '';
}
function getFontFamily(_ref3) {
  var _VARIANTS$variant$fam, _VARIANTS$variant;
  var family = _ref3.family,
    variant = _ref3.variant;
  if (family) {
    return "font-family: ".concat(family, ";");
  }
  var val = (_VARIANTS$variant$fam = (_VARIANTS$variant = VARIANTS[variant]) === null || _VARIANTS$variant === void 0 ? void 0 : _VARIANTS$variant.family) !== null && _VARIANTS$variant$fam !== void 0 ? _VARIANTS$variant$fam : 'Open Sans';
  return "font-family: ".concat(val, ";");
}
function getFontWeight(_ref4) {
  var _VARIANTS$variant2;
  var variant = _ref4.variant,
    weight = _ref4.weight;
  if (weight === 'semibold') {
    return 'font-weight: 600;';
  } else if (weight === 'bold') {
    return 'font-weight: 700;';
  }
  var val = (_VARIANTS$variant2 = VARIANTS[variant]) === null || _VARIANTS$variant2 === void 0 ? void 0 : _VARIANTS$variant2.weight;
  if (val) {
    return "font-weight: ".concat(val, ";");
  }
  return '';
}